<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>下載專區
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ ExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
      <div class="contentBox">
        <!-- left -->
        <div class="proLeft NoShowInMobile align_c">
          <img src="@/assets/images/iconDownload.svg" width="100%" />
        </div>
        <!-- left end -->
        <!-- right -->
        <div class="proRight">
          <div class="MbDevice">
            <div class="d-flex align-items-center">
              <div>
                <img
                  src="@/assets/images/iconDownload.svg"
                  width="35px"
                  class="mt-1 mr-1"
                />
              </div>
              <div>
                <h1>下載專區</h1>
              </div>
            </div>
          </div>
          <div class="PcDevice">
            <h1>下載專區</h1>
          </div>
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>

          <div>
            <div class="PcDevice">
              <table class="table">
                <thead class="thead-light text-center">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">檔案名稱</th>
                    <th scope="col">格式</th>
                    <th scope="col">大小</th>
                    <th scope="col">更新時間</th>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr v-for="(item, key) in visibleList" :key="item.No">
                    <th scope="row" class="text-center">
                      <img
                        src="@/assets/images/lock.svg"
                        width="16"
                        v-if="item.FilePermission == 'Exhibitor'"
                      />
                    </th>
                    <td class="text-left">
                      <a
                        :href="downloadUrl(item)"
                        target="_blank"
                      >
                        <i class="fas fa-file-download mr-1"></i>
                        {{ item.FileName }}
                      </a>
                    </td>
                    <td>{{ fileMeta(item, item.FileExtension) }}</td>
                    <td>{{ fileMeta(item, item.FileSize) }}</td>
                    <td>{{ item.UpdateTime }}</td>
                  </tr>
                </tbody>
              </table>

              <div
                v-if="totalPage > 1"
                class="pt-3 d-flex justify-content-center"
              >
                <nav>
                  <ul class="pagination pointer">
                    <li
                      v-if="totaltenPageNum > 1"
                      class="page-item"
                      :class="{ disabled: tenPageNum == 0 }"
                    >
                      <a
                        class="page-link"
                        title="切換前十頁"
                        aria-label="Previous"
                        @click="returntenPage()"
                      >
                        <span aria-hidden="true"
                          ><i class="fas fa-angle-double-left"></i
                        ></span>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: currentPage == 1 }"
                    >
                      <a
                        class="page-link"
                        title="上一頁"
                        aria-label="Previous"
                        @click="lastPage()"
                      >
                        <span aria-hidden="true">
                          <i class="fas fa-angle-left"></i>
                        </span>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      v-for="page in showpage"
                      :key="page"
                      :class="{ active: currentPage == page }"
                    >
                      <a class="page-link" @click="getPage(page)">{{ page }}</a>
                    </li>

                    <li
                      class="page-item"
                      :class="{ disabled: currentPage == totalPage }"
                    >
                      <a
                        class="page-link"
                        title="下一頁"
                        aria-label="Next"
                        @click="nextPage()"
                      >
                        <span aria-hidden="true"
                          ><i class="fas fa-angle-right"></i
                        ></span>
                      </a>
                    </li>
                    <li
                      v-if="totaltenPageNum > 1"
                      class="page-item"
                      :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                    >
                      <a
                        class="page-link"
                        title="切換下十頁"
                        aria-label="Next"
                        @click="nexttenPage()"
                      >
                        <span aria-hidden="true"
                          ><i class="fas fa-angle-double-right"></i
                        ></span>
                      </a>
                    </li>
                  </ul>
                  <p class="text-center mt-2">
                    第 {{ currentPage }} / {{ totalPage }} 頁
                  </p>
                </nav>
              </div>
            </div>

            <div class="MbDevice">
              <table class="table">
                <thead class="thead-light text-center">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">檔案名稱</th>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr v-for="(item, key) in visibleList" :key="item.No">
                    <th class="text-center">
                      <img
                        src="@/assets/images/lock.svg"
                        width="16"
                        v-if="item.FilePermission == 'Exhibitor'"
                      />
                    </th>

                    <td class="text-left">
                      <a
                        :href="downloadUrl(item)"
                        target="_blank"
                      >
                        <i class="fas fa-file-download mr-1"></i>
                        {{ item.FileName }}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div
                v-if="totalPage > 1"
                class="pt-3 d-flex justify-content-center"
              >
                <nav>
                  <ul class="pagination pagination-sm pointer">
                    <li
                      v-if="totaltenPageNum > 1"
                      class="page-item"
                      :class="{ disabled: tenPageNum == 0 }"
                    >
                      <a
                        class="page-link"
                        title="切換前十頁"
                        aria-label="Previous"
                        @click="returntenPage()"
                      >
                        <span aria-hidden="true"
                          ><i class="fas fa-angle-double-left"></i
                        ></span>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: currentPage == 1 }"
                    >
                      <a
                        class="page-link"
                        title="上一頁"
                        aria-label="Previous"
                        @click="lastPage()"
                      >
                        <span aria-hidden="true">
                          <i class="fas fa-angle-left"></i>
                        </span>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      v-for="page in showpage"
                      :key="page"
                      :class="{ active: currentPage == page }"
                    >
                      <a class="page-link" @click="getPage(page)">{{ page }}</a>
                    </li>

                    <li
                      class="page-item"
                      :class="{ disabled: currentPage == totalPage }"
                    >
                      <a
                        class="page-link"
                        title="下一頁"
                        aria-label="Next"
                        @click="nextPage()"
                      >
                        <span aria-hidden="true"
                          ><i class="fas fa-angle-right"></i
                        ></span>
                      </a>
                    </li>
                    <li
                      v-if="totaltenPageNum > 1"
                      class="page-item"
                      :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                    >
                      <a
                        class="page-link"
                        title="切換下十頁"
                        aria-label="Next"
                        @click="nexttenPage()"
                      >
                        <span aria-hidden="true"
                          ><i class="fas fa-angle-double-right"></i
                        ></span>
                      </a>
                    </li>
                  </ul>
                  <p class="text-center mt-2">
                    第 {{ currentPage }} / {{ totalPage }} 頁
                  </p>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <p class="clear"></p>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      downloadList: [],
      downloadRawData: [],
      currentPage: 1,
      totalPage: "",
      totalNo: "",
      totaltenPageNum: 0,
      tenPageNum: 0,
      showpage: [],
      show: true, // 判斷有無資料
      lang: "tw",
      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
    };
  },

  metaInfo() {
    return {
      title: "下載專區 - 展昭參展商管理系統",
    };
  },

  computed: {
    //FileUrl 與 CloudUrl 都沒有值的資料不顯示
    visibleList() {
      return this.downloadList.filter(
        (item) => this.hasCloudUrl(item) || this.hasValue(item.FileUrl)
      );
    },
  },

  methods: {
    //空值、null、N/A 都視為沒有值
    hasValue(value) {
      const text = value ? String(value).trim() : "";
      return text !== "" && text.toUpperCase() !== "N/A";
    },

    hasCloudUrl(item) {
      return this.hasValue(item.CloudUrl);
    },

    //有雲端連結時，下載以雲端連結為主；否則組回原本的檔案路徑
    downloadUrl(item) {
      return this.hasCloudUrl(item)
        ? item.CloudUrl
        : `https://www.chanchao.com.tw/exhibitionfiles/download/${item.FileUrl}`;
    },

    //雲端連結沒有檔案大小與副檔名，統一顯示 -
    fileMeta(item, value) {
      if (this.hasCloudUrl(item)) return "-";
      return this.hasValue(value) ? value : "-";
    },

    getPage(page) {
      const vm = this;
      vm.currentPage = page;
      vm.newPageApi(page);
    },

    nextPage() {
      const vm = this;

      vm.currentPage = Number(vm.currentPage) + 1;
      vm.newPageApi();
    },

    lastPage() {
      const vm = this;
      vm.currentPage = Number(vm.currentPage) - 1;
      vm.newPageApi();
    },

    nexttenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum + 1;
      vm.showpage = vm.downloadRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];
      vm.newPageApi();
    },

    returntenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum - 1;
      vm.showpage = vm.downloadRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];

      vm.newPageApi();
    },

    mainPageApi() {
      const vm = this;

      const url = `/apiExhibitors/Download/${vm.RegNo}?Page=${vm.currentPage}&lang=${vm.lang}`;
      axios.get(url).then(function (response) {
        if (response.data.pagetotal > 0) {
          vm.downloadList = response.data.Data;
          vm.totalPage = response.data.pagetotal;
          vm.totalNo = response.data.datatotal;

          for (let i = 0; i < vm.totalPage; i++) {
            if (i % 10 === 0) {
              vm.downloadRawData.push([]);
            }

            const page = parseInt(i / 10); //parseInt整數公式
            vm.downloadRawData[page].push(i + 1);
          }

          //totaltenPageNum 取得共有幾筆十頁
          vm.totaltenPageNum = vm.downloadRawData.length;

          //從取得的筆數後，tenNum 計算出現第幾個十頁數

          let anaNowPage = vm.currentPage - 1; //判定第幾頁(十頁)，頁數減一避免進位

          vm.tenPageNum = parseInt(anaNowPage / 10);
          vm.showpage = vm.downloadRawData[vm.tenPageNum];

          // console.log(vm.currentPage)

          // vm.getlastpagenum()

          vm.show = true;
        } else {
          vm.show = false;
        }
      });
    },

    newPageApi() {
      const vm = this;

      const url = `/apiExhibitors/Download/${vm.RegNo}?Page=${vm.currentPage}&lang=${vm.lang}`;

      axios.get(url).then(function (response) {
        vm.downloadList = response.data.Data;
      });
    },
  },

  created() {
    const vm = this;

    //語系會自動抓html lang tag

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
      });

    vm.mainPageApi();
  },
};
</script>

<style lang="scss"></style>
